<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 max-w-xl">
        <div class="mb-12 text-center flex justify-center">
          <h1 class="font-semibold text-2xl lg:text-3xl">Success</h1>
        </div>
        <p class="leading-loose text-center mb-16">
          An email has been sent to each of the people in the order list. You can track as they open the email and
          complete their orders from the order page.
        </p>
        <div class="flex justify-center">
          <router-link :to="`/orders/${order.uuid}`">
            <button class="btn btn-primary font-semibold rounded-lg px-16">
              Go to Order
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      order() {
        return this.$store.state.currentEditingOrder
      }
    }
  }
</script>